/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Selection_EmptyInputs */

const en_admin_user_list_mail_selection_empty = /** @type {(inputs: Admin_User_List_Mail_Selection_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No selected users have an email address.`)
};

const de_admin_user_list_mail_selection_empty = /** @type {(inputs: Admin_User_List_Mail_Selection_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine ausgewählten Nutzer haben eine E-Mail-Adresse.`)
};

/**
* | output |
* | --- |
* | "No selected users have an email address." |
*
* @param {Admin_User_List_Mail_Selection_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_selection_empty = /** @type {((inputs?: Admin_User_List_Mail_Selection_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Selection_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_selection_empty(inputs)
	return en_admin_user_list_mail_selection_empty(inputs)
});